/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import "react-datepicker/dist/react-datepicker.css";

//Import PageHeader
import PageHeader from "../../components/PageHeader";
// Redux Store
import PartnerThroughMeCompanies from "../../components/Partner/PartnerThroughMeCompanies";

const ManagingThroughMeCompanies = () => {
  return (
    <>
      <PageHeader
        title={`안녕하세요, 홈페이지를 통해 유입된 기업입니다. `}
      />
      <PartnerThroughMeCompanies />
    </>
  );
};

export default ManagingThroughMeCompanies;
